// Determine environment
// const isDevelopment = process.env.NODE_ENV === 'development';

// Environment specific configuration
interface Config {
  galleryBaseUrl: string;
  apiBaseUrl: string;
}

const config: Config = {
  // Base URL for gallery content (images and static files)
  // In production, use the same domain (empty string means same domain)
  // In development, point to the local dev server
  galleryBaseUrl: "",

  // Base URL for API endpoints
  // APIs are served at /api/* through CloudFront on the same domain
  apiBaseUrl: "/api",
};

export default config;
